import { render } from "./MsgAlert.vue?vue&type=template&id=25c9fd63&scoped=true"
import script from "./MsgAlert.vue?vue&type=script&lang=js"
export * from "./MsgAlert.vue?vue&type=script&lang=js"

import "./MsgAlert.vue?vue&type=style&index=0&id=25c9fd63&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c9fd63"]])

export default __exports__